/* eslint-disable */
import * as Types from '../../../models/schema.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateServiceReportVariablesDTO = Types.Exact<{
  id: Types.Scalars['String'];
  workingHours?: Types.InputMaybe<Array<Types.TimeBlockInputDTO> | Types.TimeBlockInputDTO>;
  articlesRetoured?: Types.InputMaybe<Types.Scalars['String']>;
  articlesToOrder?: Types.InputMaybe<Types.Scalars['String']>;
  remainingWork?: Types.InputMaybe<Types.Scalars['String']>;
  remainingWorkManPower?: Types.InputMaybe<Types.Scalars['Int']>;
  commentForCustomer?: Types.InputMaybe<Types.RemarkInputDTO>;
  executedWork?: Types.InputMaybe<Types.Scalars['String']>;
  endMileage?: Types.InputMaybe<Types.Scalars['Int']>;
  pictures?: Types.InputMaybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
}>;


export type UpdateServiceReportDTO = { __typename?: 'Mutation', updateOneServiceReport: { __typename?: 'ServiceReport', id: string } };


export const UpdateServiceReportDocumentDTO = gql`
    mutation updateServiceReport($id: String!, $workingHours: [TimeBlockInput!], $articlesRetoured: String, $articlesToOrder: String, $remainingWork: String, $remainingWorkManPower: Int, $commentForCustomer: RemarkInput, $executedWork: String, $endMileage: Int, $pictures: [String!]) {
  updateOneServiceReport(
    id: $id
    data: {workingHours: $workingHours, articlesRetoured: $articlesRetoured, articlesToOrder: $articlesToOrder, remainingWork: $remainingWork, remainingWorkManPower: $remainingWorkManPower, remarkForCustomer: $commentForCustomer, executedWork: $executedWork, endKm: $endMileage, pictures: $pictures}
  ) {
    id
  }
}
    `;
export type UpdateServiceReportMutationFnDTO = Apollo.MutationFunction<UpdateServiceReportDTO, UpdateServiceReportVariablesDTO>;

/**
 * __useUpdateServiceReport__
 *
 * To run a mutation, you first call `useUpdateServiceReport` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceReport` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceReport, { data, loading, error }] = useUpdateServiceReport({
 *   variables: {
 *      id: // value for 'id'
 *      workingHours: // value for 'workingHours'
 *      articlesRetoured: // value for 'articlesRetoured'
 *      articlesToOrder: // value for 'articlesToOrder'
 *      remainingWork: // value for 'remainingWork'
 *      remainingWorkManPower: // value for 'remainingWorkManPower'
 *      commentForCustomer: // value for 'commentForCustomer'
 *      executedWork: // value for 'executedWork'
 *      endMileage: // value for 'endMileage'
 *      pictures: // value for 'pictures'
 *   },
 * });
 */
export function useUpdateServiceReport(baseOptions?: Apollo.MutationHookOptions<UpdateServiceReportDTO, UpdateServiceReportVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceReportDTO, UpdateServiceReportVariablesDTO>(UpdateServiceReportDocumentDTO, options);
      }
export type UpdateServiceReportHookResult = ReturnType<typeof useUpdateServiceReport>;
export type UpdateServiceReportMutationResultDTO = Apollo.MutationResult<UpdateServiceReportDTO>;
export type UpdateServiceReportMutationOptionsDTO = Apollo.BaseMutationOptions<UpdateServiceReportDTO, UpdateServiceReportVariablesDTO>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    